import {createClient, type ClientConfig} from '@sanity/client'

const config: ClientConfig = {
  projectId: 'h0qmq4c2',
  dataset: 'production',
}

const sanityClient = createClient(config)
export default sanityClient